import { API } from "common";

export const passwordReset = ({ email, origin }) => {
  return API.post(
    "/password/reset",
    {
      email,
    },
    {
      params: {
        origin,
      },
    }
  );
};
